'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const marketingCampaignMap = {
  'sea-simulation': 'CP-MK-ACQ_Recherche_mots_clés_simulation',
  'sea-desficalisation': 'CP-MK-ACQ_Recherche_mots_clés_défiscalisation',
  'lead-nurturing': 'CP-MK-ACQ_Lead_Nurturing',
  retraite: 'CP-MK-ACQ_Temps_fort_retraite',
  'relance-vel': 'CP-MK-ACQ_Relance_VEL',
} as const;

const sourceMap = {
  google: 'Lien sponsorisé Google',
  Meta: 'META',
  communication: 'COMMUNICATION CORPORATE',
  Linkedin: 'Linkedin',
  email: 'EMAILING',
} as const;

export const useMarketingData = () => {
  const searchParams = useSearchParams();
  const [googleClickId, setGoogleClickId] = useState('');

  const pkCampaign = searchParams.get('pk_campaign') ?? '';
  const source = searchParams.get('pk_source') ?? '';
  const urlGclid = searchParams.get('gclid') ?? '';

  // Extract GCLID from URL params or browser cookies (Google Ads sets it automatically)
  useEffect(() => {
    // If gclid in URL, use it
    if (urlGclid) {
      setGoogleClickId(urlGclid);
      return;
    }

    // Otherwise try to get from browser cookies
    if (typeof document !== 'undefined') {
      const cookieValue = document.cookie
        .split(';')
        .find((cookie) => cookie.trim().startsWith('gclid='))
        ?.split('=')[1];

      setGoogleClickId(cookieValue ? decodeURIComponent(cookieValue) : '');
    }
  }, [urlGclid]);

  return {
    marketingCampaign: marketingCampaignMap[pkCampaign] ?? '',
    sourcePartner: sourceMap[source] ?? sourceMap['google'],
    googleClickId,
  };
};
